import React from "react"
import classNames from "classnames"
import numeral from "numeral"
import Icon from "../Icon/Icon"
import {ProgramPerformanceItem} from "./types"

interface ProgramPerformanceItemCardProps extends ProgramPerformanceItem {
	className?: string
}

export function ProgramPerformanceItemCard({
	icon,
	title,
	value,
	formatAsCurrency,
	className,
	onClick,
}: ProgramPerformanceItemCardProps) {
	const formattedValue = formatAsCurrency
		? numeral(Number(value) / 100).format("0,0.00")
		: numeral(Number(value)).format("0,0")

	return (
		<div
			className={classNames("program-performance-item-card", className, onClick && "is-clickable")}
			onClick={onClick}
			style={onClick ? {cursor: "pointer"} : undefined}
		>
			<div className="program-performance-item-card-header">
				<div className="program-performance-item-card-icon">
					<Icon icon={icon} size="16" />
				</div>
				<div className="program-performance-item-card-title">{title}</div>
			</div>
			<div className="program-performance-item-card-value">
				{formatAsCurrency && <span className="program-performance-item-card-currency">$</span>}
				{formattedValue}
			</div>
		</div>
	)
}
